<template>
  <v-col class="pa-0">
    <v-row class="ma-0 pa-0">
      <v-col
        align="center"
        cols="8"
        offset="2"
        class="pa-0 pt-3"
      >
        <h2 class="titleThanks">{{$translate('LINDA_REGISTER_DONE')}}</h2>
      </v-col>
      <v-col class="text-right">
        <v-icon
          size="20"
          @click="$emit('triggerPopup', {toggle: false, component:'Login'})"
        >
          ti-close
        </v-icon>
      </v-col>
    </v-row>
    <v-col align="center" justify="center" class="py-5">
      <v-icon
        size="140"
        color="#a7dc86"
      >
        done_outline
      </v-icon>
    </v-col>
    <v-col align="center" justify="center" class="pa-3">
      <p>{{ $translate('REGISTER_CONFIRMATION_EMAIL') }}</p>
      <v-alert
        color="blue"
        text
        type="info"
      >
        {{ $translate('REGISTER_SPAM_WARNING') }}
      </v-alert>
    </v-col>
  </v-col>
</template>

<script>
import uiHelpers from '../../shared/ui_helpers';

export default {
  name: 'AccountRegisterSuccess',
  mixins: [uiHelpers],
  data() {
    return {};
  },
  mounted() {
  },
  computed: {},
  methods: {},
};
</script>

<style scoped>
.titleThanks {
  font-size: 2rem !important;
  color: #101010;
  font-weight: 400;
}
</style>
